import React from 'react'
import { 
   StyledAuthorImg, 
   StyledAuthorName, 
   StyledAuthors, 
   StyledDate, 
   StyledPostInfo,
   StyledAuthorImagesContainer 
} from './styles'
import { GatsbyImage } from 'gatsby-plugin-image'
import defaultAuthorImg from 'assets/img/mcc_defaultAuthor.png'

export default function PostInfo({ authors, date, timeRead, isFeatured, mobile }) {
   return (
      <StyledPostInfo $mobile={mobile} $isFeatured={isFeatured}>
         {Array.isArray(authors) ? (
            <StyledAuthors>
               <StyledAuthorImagesContainer $totalAuthors={authors.length}>
                  {authors.map((author, index) => (
                     <StyledAuthorImg key={author.id} n={index}>
                        {author.profilePhoto?.gatsbyImage && (
                           <GatsbyImage image={author.profilePhoto.gatsbyImage} alt={author.name} />
                        )}
                     </StyledAuthorImg>
                  ))}
               </StyledAuthorImagesContainer>

               <StyledAuthorName>
                  <span>by&nbsp;</span>

                  {authors.map((author, index) => {
                     if (index > 0) {
                        return (
                           <React.Fragment key={author.id}>
                              <span> & </span>

                              <span>
                                 {author.socialUrl ? (
                                    <a href={author.socialUrl} target="_blank" rel="noreferrer">
                                       {author.name}
                                    </a>
                                 ) : (
                                    author.name
                                 )}
                              </span>
                           </React.Fragment>
                        )
                     }

                     return (
                        <span key={author.id}>
                           {author.socialUrl ? (
                              <a href={author.socialUrl} target="_blank" rel="noreferrer">
                                 {author.name}
                              </a>
                           ) : (
                              author.name
                           )}
                        </span>
                     )
                  })}
               </StyledAuthorName>
            </StyledAuthors>
         ) : (
            <StyledAuthors>
               <div>
                  <StyledAuthorImg>
                     <img src={defaultAuthorImg} alt="Multicoin capital" />
                  </StyledAuthorImg>
               </div>

               <StyledAuthorName>
                  <span>By Multicoin Capital</span>
               </StyledAuthorName>
            </StyledAuthors>
         )}

         <StyledDate className="dateData" $isFeatured={isFeatured}>
            {date} | {timeRead}
         </StyledDate>
      </StyledPostInfo>
   )
}
